export default __webpack_public_path__ + "static/media/Zander_pfp.ed2b2aba.png";